export const STEP = {
  CHROME: "chrome",
  PERMISSION: "permission",
  FALLBACK: "fallback",
  FALLBACK_TWO: "fallback_two",
  FAIL: "fail",
};